import {setGaEvent, pushDataLayer} from '@optimaxdev/analytics/mobile';

import {logWithSentry} from 'libs/sentry/sentry';
import {getVisitorId} from 'libs/user/getVisitorId';

/**
 * Set dimension function.
 * @param {string} fieldName - type.
 * @param {string} fieldValue - prescription.
 */
export default function setDimension(fieldName: string, fieldValue: string) {
    setGaEvent(fieldName, fieldValue, () =>
        logWithSentry(new Error("Dimension wasn't set"), {dimension: fieldName, value: fieldValue}),
    );
}

/**
 * Send dimension65 after ReactPV event
 */
export const sendCommonAnalytics = () => {
    pushDataLayer({
        Backend_visitor_id: getVisitorId(),
    });
};

/**
 * Send custom dimension event to mark end of dataLayer
 */
export const sendCustomDimensionEvent = () => {
    pushDataLayer({event: 'CDCollector'});
};

/**
 * Remove slash in the end of url pathname, e.g '/sunglasses/' => '/sunglasses'
 * @param {string} pathName - url path name
 * @returns {string} modified path name without slash in the end
 */
export const removeLastSlashInPathName = (pathName: string) => {
    return pathName.replace(/^(.+?)\/*?$/, '$1');
};

/**
 * Get location info for reactpv analytics event
 * @returns {{page: string}} - location info
 */
export const getAnalyticsLocationInfo = () => {
    if (__NODEJS__) return {};
    const {pathname, search} = window.location;
    const modifiedPathName = removeLastSlashInPathName(pathname);
    return {
        page: `${modifiedPathName}${search}`,
    };
};
